const DEFAULT_ACTION_TITLES = {
  create: { name: '创建', nameEn: 'Create' },
  edit: { name: '修改', nameEn: 'Edit' },
  approve: { name: '审批', nameEn: 'Approve' },
  view: { name: '查看', nameEn: 'View' },
}

export const normalizeRouteKey = (key = '') =>
  String(key).replace(/^\/+|\/+$/g, '')

export const getActionTitle = (action, actionTitles = {}) => {
  const title = actionTitles[action] || DEFAULT_ACTION_TITLES[action]
  return title || { name: action, nameEn: action }
}

const getDetailText = (text = '', fallbackSuffix = '') => {
  if (!text) return text
  if (text.includes('列表')) return text.replace(/列表$/, '详情')
  if (/list$/i.test(text)) return text.replace(/list$/i, 'Detail')
  return `${text}${fallbackSuffix}`
}

export const getDetailTitle = (route = {}) => {
  if (route.detailName || route.detailNameEn) {
    return {
      name: route.detailName || route.name,
      nameEn: route.detailNameEn || route.nameEn || route.detailName || route.name,
    }
  }

  return {
    name: getDetailText(route.name, '详情'),
    nameEn: getDetailText(route.nameEn || route.name, ' Detail'),
  }
}

export const matchDynamicDetailRoute = (pathname, routes = []) => {
  const routeKey = normalizeRouteKey(pathname)
  if (!routeKey) return null

  const detailPathRoute = routes.find((route) => {
    const detailPath = normalizeRouteKey(route.detailPath || route.detailFormRoute)
    return (
      detailPath &&
      (routeKey === detailPath || routeKey.startsWith(`${detailPath}/`))
    )
  })
  if (detailPathRoute) {
    const detailPath = normalizeRouteKey(
      detailPathRoute.detailPath || detailPathRoute.detailFormRoute
    )
    const rest = routeKey.slice(detailPath.length).replace(/^\/+/, '')
    const isCreate = rest === 'create' || !rest
    const action = isCreate ? 'create' : 'view'

    return {
      parentKey: normalizeRouteKey(detailPathRoute.key),
      detailKey: routeKey,
      action,
      id: isCreate ? '' : rest,
      parentRoute: detailPathRoute,
      actionTitle: getActionTitle(action, detailPathRoute.detailActionTitles),
      detailTitle: getDetailTitle(detailPathRoute),
    }
  }

  const segments = routeKey.split('/')
  for (let actionIndex = segments.length - 1; actionIndex >= 1; actionIndex--) {
    const parentKey = segments.slice(0, actionIndex).join('/')
    const action = segments[actionIndex]
    const id = segments.slice(actionIndex + 1).join('/') || ''
    const parentRoute = routes.find(
      (route) => normalizeRouteKey(route.key) === parentKey
    )

    if (parentRoute?.detailPath) {
      return {
        parentKey,
        detailKey: routeKey,
        action,
        id,
        parentRoute,
        actionTitle: getActionTitle(action, parentRoute.detailActionTitles),
        detailTitle: getDetailTitle(parentRoute),
      }
    }
  }

  return null
}

export const buildDynamicDetailCacheRoute = (detailRoute, lang = 'zh-CN') => {
  const { detailKey, detailTitle, id } = detailRoute

  return {
    cacheKey: detailKey,
    path: `/${detailKey}`,
    name: detailTitle.name,
    nameEn: detailTitle.nameEn,
    subTitle: id,
  }
}

export const getDynamicDetailBreadcrumb = (parentBreadcrumb = [], detailRoute) => {
  if (!detailRoute) return parentBreadcrumb
  if (!parentBreadcrumb.length) return [detailRoute.detailTitle]

  return [
    ...parentBreadcrumb.slice(0, parentBreadcrumb.length - 1),
    detailRoute.detailTitle,
  ]
}
